export default {
  name: 'Title',
  edit: {
    form: 'name-input',
    label: 'Edit Title',
    handler: value => value,
  },
};
